var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgErroricon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.33203 5.5026H7.66536V4.16927H6.33203V5.5026ZM6.9987 12.8359C4.0587 12.8359 1.66536 10.4426 1.66536 7.5026C1.66536 4.5626 4.0587 2.16927 6.9987 2.16927C9.9387 2.16927 12.332 4.5626 12.332 7.5026C12.332 10.4426 9.9387 12.8359 6.9987 12.8359ZM6.9987 0.835938C6.12322 0.835937 5.25631 1.00838 4.44747 1.34341C3.63864 1.67844 2.90371 2.1695 2.28465 2.78856C1.03441 4.0388 0.332031 5.73449 0.332031 7.5026C0.332031 9.27071 1.03441 10.9664 2.28465 12.2166C2.90371 12.8357 3.63864 13.3268 4.44747 13.6618C5.25631 13.9968 6.12322 14.1693 6.9987 14.1693C8.76681 14.1693 10.4625 13.4669 11.7127 12.2166C12.963 10.9664 13.6654 9.27071 13.6654 7.5026C13.6654 6.62712 13.4929 5.76022 13.1579 4.95138C12.8229 4.14254 12.3318 3.40762 11.7127 2.78856C11.0937 2.1695 10.3588 1.67844 9.54992 1.34341C8.74108 1.00838 7.87418 0.835938 6.9987 0.835938ZM6.33203 10.8359H7.66536V6.83594H6.33203V10.8359Z",
    fill: "#DC2626"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErroricon);
export default __webpack_public_path__ + "static/media/erroricon.bcb4023a.svg";
export { ForwardRef as ReactComponent };